import React from "react";
import "./Home.css"

import hero_image from "../../img/Screenshots/Community Build.png"
import diverse_membership from"../../img/Screenshots/Jeje&sharkfist playing with slime.png"
import shopping_district from "../../img/Screenshots/Shopping District.png"
import netherhub from "../../img/Screenshots/Nether Hub.png"
import MinecraftButton from "../../components/minecraft_button/Minecraft_Button";

function Home() {
    return ( 
    <div className="home-body"> 

        <img className="hero-image" src={hero_image} alt="a community build on the Mindpunch server. "/>
        
        <div className="Home-Snapshot-Container snapshot1" >
            <div className="Home-Inner-Container">
                
                <div className="snaptshot-text">
                    <h1>
                        Diverse Membrship
                    </h1>

                    <p>
                        The Mindpunch community is a global community having had members from across 5 continents. With a family friendly attitude a home can be found for anyone here on the Mindpunch server. 
                    </p>

                    <MinecraftButton to="Members/" label="Members"/>
                </div>
                

                <img  src={diverse_membership} alt="jeje162 and Sharkfist playing with slime blocks next to the world border from Season 10"/>

            </div>
        </div>
        
        <div className="Home-Snapshot-Container snapshot2">
            <div className="Home-Inner-Container">

                <img className="shopping_district" src={shopping_district} alt="shopping district"/>

                <div className="snaptshot-text">
                    <h1>
                        An engaging Community
                    </h1>

                    <p>
                        The server has a emphasis on community engagement and take lengths of creating oppurtunites to ensure that players have the oppurtunity to interact with each other even from opposite timezones. 
                    </p>
                </div>


            </div>
        </div>
        
        <div className="Home-Snapshot-Container snapshot3">
            <div className="Home-Inner-Container">
                
                <div className="snaptshot-text">

                    <h1>
                        A Rich History
                    </h1>

                    <p>
                        Having been around for over 10 years the Miindpunch commuinity has a rich and vibrant history with many players leaving a legacy which has shaped the commuinity into what it is today. 
                    </p>

                    <MinecraftButton to="History" label="Our History" />
                </div>
                <img className="nether_hub" src={netherhub} alt="the Season 11 Nether hub"/>

            </div>
        </div>

    </div>


    );

}

export default Home;